export const dateFormats = {
  default: "MM/DD/YYYY",
  iso: "YYYY-MM-DD",
};
